<script>
    //import T from '@scanex/translations';
    import {createEventDispatcher} from 'svelte';
    import './Info.css';
    import sipinfo from './sipinfo.svelte';
    import { onMount } from 'svelte';

    onMount(() => {
      console.log("TILE - MOUNT!")
      values.options = init_format_opts;
      //values.settings = {};
    })

    export let tileName = '';

	//export let granules = [];

    const dispatch = createEventDispatcher();

    let container;

    export function adjustPosition ({top, left}) {
        container.style.top = `${top}px`;
        container.style.left = `${left}px`;
    }

    import Form from "@svelteschool/svelte-forms"; // unresolved ?
    import { bind } from 'svelte/internal';

    export let values = {};
    //export let settings = [];
    export let settings = {"hist": false, "orto": false, "fuse": false, "atm": false, "ndvi": false};
    let rangevalue = 3;
    export let hist_set = {"hist_mode":"hist_null", "hist_type":"None", "rangevalue":rangevalue};
    export let atm_set = {"atm_set":"Atmosphere" };
    values.settings = settings;
    values.hist_set = hist_set;
    values.atm_set = atm_set;
    export let values2 = {};
    let sipvalues = {};

    // Переписать resetradio, setcheckbox
    const resetradio = (checkbox) => {
    var buttons = document.querySelector('.buttons');
    var radios = document.getElementsByName('atm_set');
    radios[0].checked = true;
    if (checkbox.checked == true) {
        buttons.style.display = 'block';
    }
    else {
        buttons.style.display = 'none';
    }
}

const setcheckbox  = () => {
    //var checkbox = document.getElementsByName('featured_ad')[0]; // setting atm
    var checkbox = document.getElementById('m4');
    if (checkbox.checked == false) {
        checkbox.checked = true;
    }
}

/*$(':checkbox').on("click", function(event) { 
  if (this.checked) 
    $(':radio:first').prop('checked', this.checked); 
  else 
    $(':radio').prop('checked', this.checked); 
});*/

    let sipcontainer;
    let sipwindow;
    let init_format_opts = {pixel: '1', filter: '1', channel: '1', pixelsize: '512', proj: 'WGS-84' };

const showsip = (e) => {
  console.log('sipwindow',sipwindow);
  if (!sipwindow ) {
    sipwindow = new sipinfo({
          target: document.body,
      });
        const {top, left, width} = sipcontainer.getBoundingClientRect();
        sipwindow.adjustPosition({top: top + 20, left: left - width/2 - 10 });
        sipwindow.$on('close', () => {
          sipwindow.$destroy();
          sipwindow = null;
        });
        sipwindow.$on('change', (e) => {
          console.log('change', e.detail);
          values.options = e.detail;
        });
    } else {
      //sipwindow.$destroy();
      //sipwindow = null;
      //console.log(sipwindow);
      console.log('hiddenshow');
      sipwindow.hiddenshow();
    }
    };

    const closesip = () => {
      if (sipwindow) {
        sipwindow.$destroy();
        sipwindow = null;
      }
      console.log("closesip");
    }

    const testClick = () => {
      console.log('Click!');
    }

    const handleInput = e => {
      const newOpts = e.target;
      values.settings[newOpts.name] = newOpts.checked;
    
  };
  const handleHist = e => {
      const newOpts = e.target;
      values.hist_set[newOpts.name] = newOpts.value;
    
  };
  const handleAtm = e => {
      //console.log('handleAtm');
      const newOpts = e.target;
      values.atm_set[newOpts.name] = newOpts.value;
    
  };

</script>

<div class="scene-info" bind:this="{container}">
    <table class="header" cellpadding="0" cellspacing="0">
        <tr>
            <td> <span style="display:block">{tileName}</span></td>
            <td on:click|stopPropagation="{() => dispatch('close') | closesip()}">
                <i class="icon close"></i>
            </td>
        </tr>        
    </table>
    <table class="content" cellpadding="0" cellspacing="0" bind:this="{sipcontainer}">
        <tr >
            <i class="icon format-image" on:click="{() => showsip() }"></i>
            <th>{'Формат записи'}</th>
        </tr>
    </table>
    
    <Form >
          <div class="input">
          <label></label>
          <ul>
            <li>
              <input id="m1" type="checkbox" name="hist" on:change={handleInput}/>
              <label for="m1">Настройка гистограммы сохраняемого растра</label>
            </li>
            <ul>
                <li>
                  <input id="g1" type="radio" name="hist_mode" value="None" on:change={handleHist} />
                  <label for="g1">Без коррекции гистограммы</label>
                </li>
                <li>
                  <input id="g2" type="radio" name="hist_type" value="hist_stat" />
                  <label for="g2">Настройка статистическими методами</label>
                </li>
                <ul>
                  <li>
                    <input id="g21" type="radio" name="hist_mode" value="Std" on:change={handleHist} />
                    <label for="g21">Стандартные отклонения</label>
                    <input type=range list="tickmarks" min=1 max=6 name="rangevalue" value={rangevalue} />
                    <datalist id="tickmarks">
                      <option value="1" label="1">
                      <option value="2" label="2">
                      <option value="3" label="3">
                      <option value="4" label="4">
                      <option value="5" label="5">
                      <option value="6" label="6">
                    </datalist>
                  </li>
                  <li>
                    <input id="g22" type="radio" name="hist_mode" value="Linear" on:change={handleHist}/>
                    <label for="g22">Лин-е растяжение</label>
                    <input type=range list="tickmarks" min=1 max=6 name="rangevalue2" bind:value={rangevalue} />

                  </li>
                </ul>
                <li style="display:none;">
                  <input id="g3" type="radio" name="option11" value="r3" />
                  <label for="g3">3</label>
                </li>
              </ul>
            <li>
              <input id="m2" type="checkbox" name="orto" on:change={handleInput}/>
              <label for="m2">Ортотрансформирование</label>
            </li>
            <li>
                <input id="m3" type="checkbox" name="fuse" on:change={handleInput}/>
                <label for="m3">Увеличение пространственного разрешения мультиспектрального растра по панхроматическому</label>
              </li>
              <li>
                <input id="m4" type="checkbox" name="atm" on:change={handleInput} on:click={() => resetradio(this)} />
                <label for="m4">Пересчет в значения отражательной способности и атмосферная коррекция</label>
              </li>
                <div class="buttons">
                    <input type="radio" name="atm_set" value="Reflectance" on:change={handleAtm} on:click={() => setcheckbox()}>Пересчет в значения отражательной способности(Reflectance)<br>
                    <input type="radio" name="atm_set" value="Radiance" on:change={handleAtm} on:click={() => setcheckbox()}>Пересчет в значения мощности излучения на сенсоре(Radiance)<br>
                    <input type="radio" name="atm_set" value="Atmosphere" on:change={handleAtm} on:click={() => setcheckbox()}>Параметрическая атмосферная коррекция<br>
                </div>
              <li>
                <input id="m5" type="checkbox" name="ndvi" value="ndvi" on:change={handleInput}/>
                <label for="m5">Расчет NDVI</label>
              </li>
          </ul>
        </div>
      
      </Form>

     
  <div style="width:100%; height:100%" class="search-options-footer1">
    <button
        style=" left:30%; position:relative"
        type="button"
        on:click="{() => dispatch('process', {...values, tileName})}"
        on:click="{() => dispatch('process1', {...values2})}"
        class="search-options-search-button search-options-search-button-active"
    >
        <span>Запустить обработку</span>

</div>


</div>

<style>

.format-image {
    background-image: url('img/rec_format.png');
    background-repeat: no-repeat;
    display: inline-block;
}

  table, div{
    background: #FFFFFF;
    border: 1px solid #D8E1E8;
    box-sizing: border-box;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.11);
    border-radius: 4px;
  }

  label,  input{
    font-family: 'IBM Plex Sans';
  	font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #10161A;
  }

input[type="range"]::-moz-range-progress {
    width: 30%;
    margin: 0;
    box-sizing: border-box;
    border-radius: 5px
    
}
datalist {
    display: flex;
    width: 30%;
    justify-content: space-between;
    margin-top: 23px;
    padding-top: 0px;
}
option {
    width: 2ex;
    display: flex;
    justify-content: center;
    height: 24px;
    align-items: end;
    height: 4ex;
    background-position-y: -15px;
    background-position-x: center;
    z-index: -1;
}

</style>